<div mat-dialog-title class="dialog-popup-header" style="display: flex; justify-content: space-between;">
    <h4 >Agreements</h4>
    <button mat-icon-button aria-label="close dialog" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content class="agreement-content">

    <div class="sub-header">
        <h2>Agreement</h2>
    </div>


    <pre [innerHTML]="data.content"></pre>

    <div *ngIf="data.petNames && data.petNames != ''">
        <h3 style="font-size: 13px;">For Pet(s) : {{data.petNames}}</h3>
    </div>

    <div style="display:flex; justify-content: center; align-items: center;">
        <div>
            <div>
                <label>Signed By</label>
                <input type="text" [(ngModel)]="signedBy" class="form-control" placeholder="Enter name here.." style="width: 300px; margin: auto" required>
            </div>
              
            
            <canvas class="signature-pad-canvas"></canvas>

            <br />

            <div style="display:flex; justify-content: center; align-items: center;">
                <button mat-raised-button (click)="clearSignaturePad()">Clear</button>
                <div style="margin-left:5px;"></div>
                <button mat-button class="btn btn-custom" (click)="submit()" [disabled]="disableBtn">Submit</button>
            </div>
        </div>
    </div>

    <div style="margin-bottom:15px;"></div>
</mat-dialog-content>
